module.exports = __webpack_public_path__ + "img/Page avantages étudiants.189fcf9.png";